// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".648644d6cf3bda354a6fb1fa8a6185efc0a5ec14.chunk.js";
};